module.exports = __webpack_public_path__ + "static/media/hse.93958a68.png";